<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-4">
              <strong>Content Issues</strong>
            </h5>
            <content-issues />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-4">
              <strong>Users</strong>
            </h5>
            <user-table />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-4">
              <strong>Basic Usage</strong>
            </h5>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header border-0 pb-0">
            <div class="cui__utils__heading mb-0">
              <strong class="text-uppercase font-size-16">Finance Stats</strong>
            </div>
          </div>
          <div class="card-body">
            <cui-list-11 />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userTable from '@/components/tables/users'
import contentIssues from '@/components/tables/contentIssues'
import CuiList11 from '@/components/kit/widgets/Lists/11'
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import {
  inboundBandwidthData,
  outboundBandwidthData,
  supportCasesTableData,
  supportCasesPieData,
} from './data.json'

const boundChartistOptions = {
  showPoint: true,
  showLine: true,
  showArea: true,
  fullWidth: true,
  showLabel: false,
  axisX: {
    showGrid: false,
    showLabel: false,
    offset: 0,
  },
  axisY: {
    showGrid: false,
    showLabel: false,
    offset: 0,
  },
  chartPadding: 0,
  low: 0,
  plugins: [
    ChartistTooltip({
      anchorToPoint: false,
      appendToBody: true,
      seriesName: false,
    }),
  ],
}

const supportCasesPieOptions = {
  donut: true,
  donutWidth: 35,
  showLabel: false,
  fullWidth: true,
  plugins: [
    ChartistTooltip({
      anchorToPoint: false,
      appendToBody: true,
      seriesName: false,
    }),
  ],
}

const supportCasesTableColumns = [
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Amount',
    key: 'amount',
    dataIndex: 'amount',
    scopedSlots: { customRender: 'amount' },
  },
]

export default {
  components: {
    userTable,
    contentIssues,
    CuiList11,
  },
  data: function () {
    return {
      boundChartistOptions,
      supportCasesPieOptions,
      supportCasesTableColumns,
      inboundBandwidthData,
      outboundBandwidthData,
      supportCasesTableData,
      supportCasesPieData,
    }
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
